import React from "react";
import { Box, Chip, Grid, TextField, Typography } from "@mui/material";
import { isPurchasesMode } from "../../utils/loyaltyQualification";

const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: 2 } };

function highlightSx(active) {
    return active
        ? {
            ...fieldSx,
            "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                bgcolor: "#fff7ed",
                "& fieldset": { borderColor: "#fb923c" },
            },
        }
        : fieldSx;
}

export default function TierThresholdFields({
    form,
    onChange,
    qualificationMode,
    disabled = false,
    catalogHints = {},
}) {
    const purchases = isPurchasesMode(qualificationMode);
    const pointsHint = catalogHints.min_status_points || catalogHints.minStatusPoints;
    const countHint = catalogHints.min_purchase_count || catalogHints.minPurchaseCount;
    const amountHint = catalogHints.min_purchase_amount || catalogHints.minPurchaseAmount;

    return (
        <>
            <Grid item xs={12}>
                <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                    <Typography fontSize={12} fontWeight={700} color="#1a1a2e">Seuils</Typography>
                    <Chip
                        size="small"
                        label={purchases ? "Mode Achats — count + montant décident" : "Mode Points — points de statut décident"}
                        sx={{ height: 22, fontSize: 11, fontWeight: 600 }}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    fullWidth
                    label="Points minimum"
                    type="number"
                    value={form.min_status_points}
                    onChange={onChange("min_status_points")}
                    size="small"
                    disabled={disabled}
                    helperText={pointsHint?.help || (purchases ? "Conservé si vous repassez en mode Points" : "Décide le palier en mode Points")}
                    InputProps={{ inputProps: { min: 0 } }}
                    sx={highlightSx(!purchases)}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    fullWidth
                    label="Achats minimum"
                    type="number"
                    value={form.min_purchase_count}
                    onChange={onChange("min_purchase_count")}
                    size="small"
                    disabled={disabled}
                    helperText={countHint?.help || (purchases ? "Requis avec le montant (hors palier de base)" : "Conservé pour le mode Achats")}
                    InputProps={{ inputProps: { min: 0 } }}
                    sx={highlightSx(purchases)}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    fullWidth
                    label="Montant minimum"
                    type="number"
                    value={form.min_purchase_amount}
                    onChange={onChange("min_purchase_amount")}
                    size="small"
                    disabled={disabled}
                    helperText={amountHint?.help || (purchases ? "Requis avec le nombre d’achats (hors palier de base)" : "Conservé pour le mode Achats")}
                    InputProps={{ inputProps: { min: 0 } }}
                    sx={highlightSx(purchases)}
                />
            </Grid>
        </>
    );
}
